module.exports = __webpack_public_path__ + "dist/media/ec_comp_page_banner.d40f50e6.svg";